export const STATUS = {
  IDLE: 'idle',
  LOADING: 'loading',
  SUCCESS: 'success',
  ERROR: 'error',
};

export function createAsyncState(initialData = null) {
  return {
    data: initialData,
    status: STATUS.IDLE,
  };
}

export function canRequest(state) {
  return state.status === STATUS.IDLE || state.status === STATUS.ERROR;
}
